import React from 'react';
import { RANK, getRankFromString, getRankFromOrder } from './rank.model';
import { CurrencyFormatter } from '../CurrencyFormatter';
const getDisplayColorRank = (rank) => getRankFromString(rank).color;
const capitalizeRankInString = (rank) => (rank === null || rank === void 0 ? void 0 : rank.charAt(0).toUpperCase()) + (rank === null || rank === void 0 ? void 0 : rank.slice(1).toLowerCase());
const isPlatinumAndStayPlatinum = (currentStatus, nextStatus) => currentStatus === RANK.PLATINUM.label && nextStatus === RANK.PLATINUM.label;
const isNotPlatinumAndWillBePlatinum = (currentStatus, nextStatus) => currentStatus !== RANK.PLATINUM.label && nextStatus === RANK.PLATINUM.label;
const isCurrentRankLowerThanNextRank = (currentStatus, nextStatus) => getRankFromString(currentStatus).order < getRankFromString(nextStatus).order;
const isCurrentRankBetterThanNextRank = (currentStatus, nextStatus) => getRankFromString(nextStatus).order + 1 === getRankFromString(currentStatus).order;
const isCurrentRankTwoOrThreeRanksAboveNextRank = (currentStatus, nextStatus) => getRankFromString(nextStatus).order + 2 === getRankFromString(currentStatus).order ||
    getRankFromString(nextStatus).order + 3 === getRankFromString(currentStatus).order;
const articlesOrEurosToNextStatus = (articlesToNextStatus, eurosToNextStatus) => {
    let result = React.createElement(React.Fragment, null);
    if (articlesToNextStatus > 0) {
        result = React.createElement(React.Fragment, null,
            "en achetant ",
            articlesToNextStatus,
            " article(s)");
    }
    else if (eurosToNextStatus > 0) {
        result = (React.createElement(React.Fragment, null,
            "en cumulant ",
            React.createElement(CurrencyFormatter, { amount: eurosToNextStatus }),
            " dans votre cagnotte"));
    }
    return result;
};
const timestampToDateFormat = (timestamp) => {
    const date = new Date(timestamp);
    const format = {
        day: 'numeric',
        month: 'long',
    };
    return Intl.DateTimeFormat('fr-FR', format).format(date);
};
const computeRankingPhrase = (currentStatus, nextStatus, articlesToNextStatus, eurosToNextStatus, dateBeforeNextStatus) => {
    let result;
    const rank = capitalizeRankInString(currentStatus);
    const nextRank = capitalizeRankInString(nextStatus);
    if (isPlatinumAndStayPlatinum(rank, nextRank)) {
        result = (React.createElement("p", { className: "gray-800 f6-ns f14" },
            "Vous restez ",
            React.createElement("span", { className: `${getDisplayColorRank(nextRank)} b normal-ns f6-ns f14` }, nextRank),
            " le mois prochain. Merci de votre fid\u00E9lit\u00E9."));
    }
    else if (isNotPlatinumAndWillBePlatinum(rank, nextRank)) {
        result = (React.createElement("p", { className: "gray-800 f6-ns f14" },
            "Vous deviendrez ",
            React.createElement("span", { className: `${getDisplayColorRank(nextRank)} b normal-ns f6-ns f14` }, nextRank),
            " le mois prochain. Profitez des meilleurs avantages du Club !"));
    }
    else if (isCurrentRankLowerThanNextRank(rank, nextRank)) {
        const nextRankPlusOne = getRankFromOrder(getRankFromString(nextRank).order + 1).label;
        result = (React.createElement("p", { className: "gray-800 f6-ns f14" },
            "Bravo ! Vous serez ",
            React.createElement("span", { className: `${getDisplayColorRank(nextRank)} b normal-ns f6-ns f14` }, nextRank),
            " le mois prochain. Devenez ",
            React.createElement("span", { className: `${getDisplayColorRank(nextRankPlusOne)} b normal-ns f6-ns f14` }, nextRankPlusOne),
            ' ',
            articlesOrEurosToNextStatus(articlesToNextStatus, eurosToNextStatus),
            " avant le ",
            timestampToDateFormat(dateBeforeNextStatus),
            "."));
    }
    else if (isCurrentRankBetterThanNextRank(rank, nextRank)) {
        result = (React.createElement("p", { className: "gray-800 f6-ns f14" },
            "Le mois prochain vous serez ",
            React.createElement("span", { className: `${getDisplayColorRank(nextRank)} b normal-ns f6-ns f14` }, nextRank),
            ", conservez votre statut ",
            React.createElement("span", { className: `${getDisplayColorRank(rank)} b normal-ns f6-ns f14` }, rank),
            ' ',
            articlesOrEurosToNextStatus(articlesToNextStatus, eurosToNextStatus),
            " avant le ",
            timestampToDateFormat(dateBeforeNextStatus),
            "."));
    }
    else if (isCurrentRankTwoOrThreeRanksAboveNextRank(rank, nextRank)) {
        const nextRankPlusOne = getRankFromOrder(getRankFromString(nextRank).order + 1).label;
        result = (React.createElement("p", { className: "gray-800 f6-ns f14" },
            "Le mois prochain vous serez ",
            React.createElement("span", { className: `${getDisplayColorRank(nextRank)} b normal-ns f6-ns f14` }, nextRank),
            ", devenez",
            ' ',
            React.createElement("span", { className: `${getDisplayColorRank(nextRankPlusOne)} b normal-ns f6-ns f14` }, nextRankPlusOne),
            ' ',
            articlesOrEurosToNextStatus(articlesToNextStatus, eurosToNextStatus),
            " avant le ",
            timestampToDateFormat(dateBeforeNextStatus),
            "."));
    }
    else {
        const nextRankPlusOne = getRankFromOrder(getRankFromString(nextRank).order + 1).label;
        result = (React.createElement("p", { className: "gray-800 f6-ns f14" },
            "Vous \u00EAtes ",
            React.createElement("span", { className: `${getDisplayColorRank(rank)} b f6-ns f14` }, rank),
            ", devenez",
            ' ',
            React.createElement("span", { className: `${getDisplayColorRank(nextRankPlusOne)} b normal-ns f6-ns f14` }, nextRankPlusOne),
            ' ',
            articlesOrEurosToNextStatus(articlesToNextStatus, eurosToNextStatus),
            " avant le ",
            timestampToDateFormat(dateBeforeNextStatus),
            "."));
    }
    return result;
};
export { computeRankingPhrase, capitalizeRankInString, isPlatinumAndStayPlatinum, isNotPlatinumAndWillBePlatinum, isCurrentRankLowerThanNextRank, isCurrentRankBetterThanNextRank, isCurrentRankTwoOrThreeRanksAboveNextRank, };
